import json from "../json/errorLogger.json";

export default async () => JSON.parse(JSON.stringify(await json));
